import { Box, Button, Grow, IconButton, Paper, Tooltip, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { Colors } from '../../../../Styles/Colors'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { newAmountCard } from '../../../../Components/CommonCards/CommonCards';
import { DataGrid } from '@mui/x-data-grid';
import { DateTime } from 'luxon';
import { formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';

const STYLES = {
    FONT_SIZE_LOW_2: "0.9rem",
    FONT_SIZE_LOW_3: "0.8rem",
    FONT_WEIGHT: "bold"
};

const ServiceHeadWiseViewReport = () => {
    const [states, setStates] = useState({
        fromIPReport: false,
        page: 0,
        pageSize: 10,
        isLoader: false,
        serviceHeadData: [],
        total_amount: 0,
        amountCardData: [],
        serviceHeadId: null,
        serviceHeadName: '',
        fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
    })
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })
    const history = useHistory()

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    // API STARTS

    useEffect(() => {
        if (history?.location?.state?.fromIPReport || Object.keys(history?.location?.state?.serviceData)?.length > 0) {
            let serviceData = history?.location?.state?.serviceData
            setStates((prev) => ({
                ...prev,
                fromIPReport: history?.location?.state?.fromIPReport ?? false,
                serviceHeadId: history?.location?.state?.service_head_id ?? null,
                fromDate: history?.location?.state?.fromDate,
                toDate: history?.location?.state?.toDate,
                serviceHeadName: serviceData?.service_head_name ?? '',
                serviceHeadData: serviceData?.service_data ?? [],
                amountCardData: serviceData?.amount_list ?? [],
                total_amount: serviceData?.total_amount ?? 0
            }))
        }
    }, [history?.location?.state?.fromIPReport])

    const renderPatientCard = (item) => {
        try {
            const gender = item?.gender === 'm' ? 'M' : item?.gender === 'f' ? 'F' : 'T'
            const patientName = `${item?.patient_name || item?.first_name} ${item?.patient_age_str || item?.patient_age}/${gender}`
            const uhidMob = `${item.patient_account_number || item?.patient_account_numbers} | ${item?.mobile_number || item?.patient_mobile_number || item?.patients_mobile}`
            return (
                <Box component={'div'} sx={{ backgroundColor: "white", padding: "0.5vw" }}>
                    <Box component={'div'} sx={{ width: "20vw", display: 'flex' }}>
                        <Box component={'div'} display={'flex'} alignItems={'center'}>
                            <Box component={'div'}>
                                {patientName ? patientName?.length > 25 ?
                                    <Tooltip placement='top' title={patientName}><Typography noWrap fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={STYLES.FONT_WEIGHT}>{patientName?.slice(0, 25) + '...'}</Typography></Tooltip> :
                                    <Typography noWrap fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={STYLES.FONT_WEIGHT}>{patientName}</Typography> : '-'}
                                {uhidMob ? uhidMob?.length > 20 ?
                                    <Tooltip placement='top' title={uhidMob}><Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{uhidMob?.slice(0, 18) + '...'}</Typography></Tooltip> :
                                    <Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{uhidMob}</Typography> : '-'}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderTable = () => {
        states.serviceHeadData?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'patient_name', headerName: 'Patient Details', flex: 0.125,
                renderCell: (params) => {
                    let patientDetails = params?.row
                    return (
                        <Box component={'div'}>{renderPatientCard(patientDetails)}</Box>
                    )
                }, valueGetter: (params) => {
                    const name = params.row?.patient_name || "";
                    const mobile = params.row?.patient_mobile_number || "";
                    const UHID = params.row?.patient_account_numbers || "";
                    return `${name} ${mobile} ${UHID}`;
                }
            },
            {
                field: 'invoice_no', headerName: 'Bill Details', flex: 0.125,
                renderCell: (params) => {
                    let BillDetail = params?.row?.invoice_no
                    let date = params?.row?.invoice_date
                    return (
                        <Box component={'div'}>
                            {BillDetail ? BillDetail?.length > 20 ?
                                <Tooltip placement='top' title={BillDetail}><Typography fontSize={'0.9rem'} fontWeight={600}>{BillDetail?.slice(0, 20) + '...'}</Typography></Tooltip> :
                                <Typography fontSize={'0.9rem'} fontWeight={600}>{BillDetail}</Typography> : '-'}
                            {date ? date?.length > 20 ?
                                <Tooltip placement='top' title={date}><Typography fontSize={'0.8rem'} color={Colors.grayShade}>{date?.slice(0, 20) + '...'}</Typography></Tooltip> :
                                <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{formatDate(date)}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'service_name', headerName: 'Service Name', flex: 0.125,
                renderCell: (params) => {
                    let serviceName = params?.row?.service_name
                    return (
                        <Box component={'div'}>
                            {serviceName ? serviceName?.length > 15 ?
                                <Tooltip placement='top' title={serviceName}><Typography>{serviceName?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                <Typography>{serviceName}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'module_type', headerName: 'Module', flex: 0.125,
                renderCell: (params) => {
                    let module = params?.row?.module_type
                    return (
                        <Box component={'div'}>
                            {module ? module?.length > 10 ?
                                <Tooltip placement='top' title={module}><Typography>{module?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                <Typography>{module}</Typography> : '-'}
                        </Box>
                    )
                }
            }, {
                field: 'rate_per_unit', headerName: 'Rate/Unit', flex: 0.125,
                renderCell: (params) => {
                    let rate = params?.row?.rate_per_unit
                    return (
                        <Box component={'div'}>
                            {rate ? rate?.length > 10 ?
                                <Tooltip placement='top' title={rate}><Typography>{rate?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                <Typography>{rate}</Typography> : '0'}
                        </Box>
                    )
                }
            }, {
                field: 'discount_amount', headerName: 'Discount Amount', flex: 0.125,
                renderCell: (params) => {
                    let DisAmt = params?.row?.discount_amount
                    return (
                        <Box component={'div'}>
                            {DisAmt ? DisAmt?.length > 10 ?
                                <Tooltip placement='top' title={DisAmt}><Typography>{DisAmt?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                <Typography>{DisAmt}</Typography> : '0'}
                        </Box>
                    )
                }
            }, {
                field: 'total_amount', headerName: 'Total Amount', flex: 0.125,
                renderCell: (params) => {
                    let totalAmt = params?.row?.total_amount
                    return (
                        <Box component={'div'}>
                            {totalAmt ? totalAmt?.length > 10 ?
                                <Tooltip placement='top' title={totalAmt}><Typography>{totalAmt?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                <Typography>{totalAmt}</Typography> : '0'}
                        </Box>
                    )
                }
            }, {
                field: 'payment_type', headerName: 'Payment Type', flex: 0.125,
                renderCell: (params) => {
                    let paymentType = params?.row?.payment_type
                    return (
                        <Box component={'div'}>
                            {paymentType ? paymentType?.length > 10 ?
                                <Tooltip placement='top' title={paymentType}><Typography>{paymentType?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                <Typography>{paymentType}</Typography> : '-'}
                        </Box>
                    )
                }
            }
        ]
        return (
            <Box component={'div'} className='eMed_rts_table'>
                <DataGrid
                    rows={states.serviceHeadData}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        // Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box className='eMed_conf_nodata'>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    pageSizeOptions={[10, 20, 30]}
                    pagination
                    paginationMode="client"
                    paginationModel={{
                        page: this.state.page,
                        pageSize: this.state.pageSize
                    }}
                    onPaginationModelChange={(model) => {
                        this.setState({
                            page: model.page,
                            pageSize: model.pageSize
                        })
                    }}
                    headerHeight={40}
                    disableRowSelectionOnClick
                    loading={states.isLoader}
                />
            </Box>
        )
    }

    return (
        <Box component={'div'} sx={{ height: '85dvh', backgroundColor: Colors.Background }}>
            <Box component={'div'}>
                <Box component={'div'} height={'5dvh'} borderBottom={'2px solid lightgray'} display={'flex'} alignItems={'center'}>
                    <IconButton
                        onClick={() => {
                            const path = states.fromIPReport
                                ? '/FOReports/ServiceReports/IPServiceHeadWiseReport'
                                : '/FOReports/ServiceReports/OPServiceHeadWiseReport';
                            history?.push({
                                pathname: path,
                                state: {
                                    fromDate: states.fromDate,
                                    toDate: states.toDate,
                                    dateIndex: history?.location?.state?.dateIndex,
                                    module_type: history?.location?.state?.module_type
                                }
                            })

                            setStates((prev) => ({ ...prev, serviceHeadId: null }))
                        }}
                    ><KeyboardBackspaceIcon color='primary' /></IconButton>
                    <Typography fontSize={'1rem'} fontWeight={600}>{states.fromIPReport ? 'IP Service Head-Wise Report' : 'OP Service Head-Wise Report'}</Typography>
                </Box>
                <Box component={'div'} display={'flex'} height={'13.5dvh'} mb={'0.5rem'} p={'0.5rem 0rem'}>
                    <Paper elevation={1} sx={{ ml: '0.5rem' }}>
                        <Box component={'div'} width={'20dvw'}>
                            <Box component={'div'} borderBottom={'1.5px solid lightgray'} p={'0.3rem'}>
                                <Typography fontSize={'0.9rem'} color={Colors.grayShade}>Service Head Name</Typography>
                            </Box>
                            <Box component={'div'} display={'flex'} flexWrap={'wrap'} p={'0.3rem'} alignItems='center'>
                                <Typography fontSize={'0.9rem'} fontWeight={600}>{states.serviceHeadName ?? ''}</Typography>
                            </Box>
                        </Box>
                    </Paper>
                    <Button className='Common_Btn_Min_Width eMed_Recpt_header_amt_card' sx={{ ml: '0.5rem' }}
                        onClick={() => setStates((prev) => ({ ...prev, openTotal: !states.openTotal }))}
                    >{newAmountCard('Total Amount', states.total_amount, false, states.openTotal ? Colors.Primary : 'white', true, states.openTotal ? 'white' : Colors.Primary, 'tlt_rpt', '8dvw', '0.5rem', '10.8dvh')}</Button>
                    <Box component={'div'} display={'flex'} width={'71dvw'} overflow={'auto'} ml={'0.5rem'}>
                        {states.openTotal ?
                            <Box sx={{ display: 'flex', flexDirection: "row", mt: '0.2rem' }}>
                                {states.amountCardData?.map((item, index) => {
                                    return (
                                        <Grow in={states.openTotal} style={{ transformOrigin: '0 0 0' }} key={index}
                                            {...(states.openTotal ? { timeout: 500 } : {})}>{newAmountCard(item?.label, item?.value, false, 'white', false, 'white', 'tlt_cash', '8dvw', '0.5rem', states.amountCardData?.length > 7 ? '9dvh' : '10dvh')}</Grow>
                                    )
                                })}
                            </Box> : null}
                    </Box>
                </Box>
                <Box component={'div'}>
                    {renderTable()}
                </Box>
            </Box>
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
        </Box>
    )
}

export default ServiceHeadWiseViewReport